'use client'

import { Button } from '@/components/ui/button'
import { useLandingAuthContext } from '@/features/landing-page/landing-auth-context'

/**
 * "Get started" CTA for the vision card. Thin client leaf (mirrors NavCtaButtons) so the section
 * itself stays a server component — it only needs the landing auth context's `handleCtaClick`.
 */
export function VisionCtaButton() {
    const { handleCtaClick } = useLandingAuthContext()

    return (
        <Button variant="lp-primary" size="lp-lg" onClick={handleCtaClick} data-cta="get_started">
            Get started
        </Button>
    )
}
